import { Noto_Sans, Yellowtail } from 'next/font/google';

const notoSans = Noto_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-noto-sans',
  weight: ['400', '700'],
});

const yellowtail = Yellowtail({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-yellowtail',
  weight: ['400'],
});

export const supportedFonts = [notoSans, yellowtail];
